import React, {Component} from 'react';
import NavBar from '../navbar/NavBar';
import Footer from '../footer/Footer'
import {Route, Switch, withRouter} from 'react-router-dom';
import './MainLayout.scss';
import {RouteConstants} from "../route/services/RouteConstants";

import PrivateRoute from "../route/PrivateRoute";

import Profile from "../../pages/profile/Profile";
import AuthError from "../../pages/auth-error/AuthError";
import RedirectionError from "../../pages/auth-error/RedirectionError";
import DashboardPage from "../../pages/dashboard/DashboardPage";
import Login from "../../pages/login/Login";
import Logout from "../../pages/logout/Logout";
import AuthCallbackPage from "../../pages/auth-callback-page/AuthCallbackPage";
import ForgotPasswordPage from "../../pages/forgot-password/ForgotPassword";
import ForgotPasswordSentPage from "../../pages/forgot-password/ForgotPasswordSent";
import AddLoadConfiguration from "../app-initialization/AddLoadConfiguration";
import PasswordReset from "../../pages/forgot-password/PasswordReset";
import PasswordResetErrorPage from "../../pages/forgot-password/PasswordResetErrorPage";
import OtcAuthCallbackPage from "../../pages/auth-callback-page/OtcAuthCallbackPage";
// import TestDashboardPage from "../../pages/test-dashboard/TestDashboardPage";
import ForgotUserName from "../../pages/forgot-user-name/ForgotUserName";
import ForgotUserNameSent from "../../pages/forgot-user-name/ForgotUserNameSent";
import IncompleteRegistration from "../../pages/incomplete-registration/IncompleteRegistration";
import CompleteRegistrationRequestEmailSent from "../../pages/incomplete-registration/CompleteRegistrationRequestEmailSent";
import Registration from "../../pages/registration/Registration";
import UpdateEmailStartPage from "../../pages/update-email/UpdateEmailStartPage";
import UpdateEmailSecurityPage from "../../pages/update-email/UpdateEmailSecurityPage";
import UpdateEmailNewPage from "../../pages/update-email/UpdateEmailNewPage";
import UpdateEmailCompletePage from "../../pages/update-email/UpdateEmailCompletePage";

class MainLayout extends Component {

  constructor(props) {
    super(props);
    this.props = props;
  }

  isUpdateEmailRoute = (pathname) => {
    return pathname && pathname.startsWith(RouteConstants.UPDATE_EMAIL);
  };

  render() {
    const isUpdateEmail = this.isUpdateEmailRoute(this.props.location?.pathname);
    
    return (
        <div className="hrb-main-layout">
          {!isUpdateEmail && <Route path="/" render={props => <NavBar {...props}  />}/>}
          <div className={`hrb-container ${isUpdateEmail ? 'hrb-container-no-margin' : ''}`}>
            <Switch>
              <PrivateRoute path={RouteConstants.PROFILE} component={Profile}/>
              <Route exact path={RouteConstants.AUTH_CALLBACK} render={(props) => (<AuthCallbackPage {...props}/>)} />
              <Route path={RouteConstants.LOGIN} component={Login} />
              <Route path={RouteConstants.LOGOUT} component={Logout} />
              <Route exact path={RouteConstants.OTC_CALLBACK} render={(props) => (<OtcAuthCallbackPage {...props}/>)} />
              <Route path={RouteConstants.AUTH_ERROR} component={AuthError} />
              <Route path={RouteConstants.REDIRECTION_ERROR} component={RedirectionError} />
              <Route path={RouteConstants.FORGOT_PASSWORD_SENT} component={ForgotPasswordSentPage} />
              <Route path={RouteConstants.FORGOT_PASSWORD} component={ForgotPasswordPage} />
              <Route path={RouteConstants.INCOMPLETE_REGISTRATION} component={IncompleteRegistration} />
              <Route path={RouteConstants.COMPLETE_REGISTRATION_REQUEST_EMAIL_SENT} component={CompleteRegistrationRequestEmailSent} />
              <Route path={RouteConstants.PASSWORD_RESET_ERROR} component={PasswordResetErrorPage} />
              <Route path={RouteConstants.PASSWORD_RESET} component={PasswordReset} />
              <Route path={RouteConstants.FORGOT_USERNAME_SENT} component={ForgotUserNameSent} />
              <Route path={RouteConstants.FORGOT_USERNAME} component={ForgotUserName} />
              <Route path={RouteConstants.UPDATE_EMAIL_COMPLETE} component={UpdateEmailCompletePage} />
              <Route path={RouteConstants.UPDATE_EMAIL_NEW} component={UpdateEmailNewPage} />
              <Route path={RouteConstants.UPDATE_EMAIL_SECURITY} component={UpdateEmailSecurityPage} />
              <Route path={RouteConstants.UPDATE_EMAIL} component={UpdateEmailStartPage} />
              {/*<PrivateRoute path={RouteConstants.TEST_DASHBOARD} component={TestDashboardPage}/>*/}
              {/*Default to Dashboard, if unauthenticated, PrivateRoute with force a login*/}
              <Route path={RouteConstants.DASHBOARD} render={(props) => (<DashboardPage {...props} />)}/>
              <Route path={RouteConstants.REGISTER} component={Registration} />
              <PrivateRoute path="*" component={DashboardPage} />
            </Switch>
            {!isUpdateEmail && <Route path="/" render={props => <Footer {...props} />} />}
          </div>
        </div>
    );
  }
}

export default withRouter(AddLoadConfiguration(MainLayout));
